
import React from 'react';
import { Luggage } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyTripsStateProps {
  onCreateTrip: () => void;
}

const EmptyTripsState: React.FC<EmptyTripsStateProps> = ({ onCreateTrip }) => {
  return (
    <div 
      className="flex flex-col items-center justify-center py-16 px-6 text-center bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 rounded-lg shadow-sm"
      aria-label="No trips message"
    >
      <div className="bg-slate-100 dark:bg-slate-800 p-4 rounded-full mb-6">
        <Luggage className="h-16 w-16 text-glowingTeal" />
      </div>
      <h2 className="text-2xl font-bold mb-3 font-poppins">No Trips Found</h2>
      <p className="text-muted-foreground max-w-md mb-8">
        You haven't created or joined any trips yet. Start planning your adventure!
      </p>
      <Button 
        onClick={onCreateTrip}
        className="bg-glowingTeal hover:bg-glowingTeal/90 text-white btn-glow"
        size="lg"
      >
        Create New Trip
      </Button>
    </div>
  );
};

export default EmptyTripsState;
